<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        v-model="modelFilterFormatted"
        dense
        clearable
        single-line
        readonly
        hide-details="true"
        type="text"
        class="mt-0"
        autocapitalize="off"
        autocomplete="off"
        autocorrect="off"
        spellcheck="false"
        append-icon="mdi-calendar"
        @click:clear.prevent="clear"
      >
        <template #prepend-inner>
          <v-menu
            offset-y
            :close-on-content-click="true"
          >
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon v-text="icon"></v-icon>
              </span>
            </template>
            <v-list dense>
              <v-list-item-group
                v-model="modelType"
                color="primary"
              >
                <v-list-item
                  v-for="(item, k) in listData"
                  :key="k"
                  :value="item.key"
                  @click.prevent="icon = item.icon"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon small v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="modelFilter"
      :locale="$store.getters.locale"
      :first-day-of-week="firstDayOfWeek"
      @input="dateMenu = false"
    />
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue';
import intl from '@/utils/intl';

export default Vue.extend({
  name: 'FilterDate',
  props: {
    type: String,
    formatted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateMenu: false,
      icon: 'mdi-magnify',
      modelFilter: null,
      modelFilterFormatted: null,
      modelType: 'eq',
      listData: [
        { key: 'eq', icon: 'mdi-equal', text: intl.t('dataTableFilters.eq') },
        { key: 'lt', icon: 'mdi-less-than', text: intl.t('dataTableFilters.lt') },
        { key: 'gt', icon: 'mdi-greater-than', text: intl.t('dataTableFilters.gt') },
        { key: 'lte', icon: 'mdi-less-than-or-equal', text: intl.t('dataTableFilters.lte') },
        { key: 'gte', icon: 'mdi-greater-than-or-equal', text: intl.t('dataTableFilters.gte') }
      ]
    }
  },
  computed: {
    firstDayOfWeek(): number {
      return intl.getFirstDayOfWeek();
    }
  },
  watch: {
    modelFilter(val) {
      this.modelFilterFormatted = val ? (this.formatted ? intl.formatDate(val) : val) : null;
      this.$emit('filterValueChange', val);
    },
    modelType(val) {
      this.$emit('typeChange', val);
    }
  },
  methods: {
    clear() {
      this.icon = 'mdi-magnify';
      this.modelType = 'eq';
      this.modelFilter = null;
    }
  }
});
</script>
